import { Component, OnInit, inject, signal } from '@angular/core';
import { IBizEntity, BizEntityTypeCategory, LoggerService } from '@optima-stride-ai/core';
import { BizEntityTypeStateStoreService, FormBizEntityComponent } from '@optima-stride-ai/optima-app-framework';
import { createNewBizEntity } from '../biz-entity.factory';
import { GlobalStateService } from '../../../../../service/global.service';
import { LibraryExplorerStateService } from '../../../libraries/services/library-explorer-state.service';



@Component({
  selector: 'app-form-add-folder',
  imports: [FormBizEntityComponent],
  templateUrl: './form-add-folder.component.html',
  styleUrls: ['./form-add-folder.component.sass']
})

export class FormAddFolderComponent implements OnInit {
  private readonly logger = inject(LoggerService);
  private readonly bizEntityTypeStateStoreService = inject(BizEntityTypeStateStoreService);
  private readonly global = inject(GlobalStateService);
  private readonly libraryExplorerStateService = inject(LibraryExplorerStateService);

  public selectedBizEntityId: string | null = null;
  public bizEntity = signal<IBizEntity | null>(null);
  public isEditing = false;

  async ngOnInit(): Promise<void> {
    // Subscribe to selected entity ID to set as parent
    this.global.selectedBizEntityId$.subscribe((id) => {
      this.selectedBizEntityId = id;
    });
    // this.relationshipStateStoreService.changed?.subscribe(() => {
    //   console.log('Relationship state changed, current value:', this.relationshipStateStoreService.getState());
    //   this.global.setBizEntityCreated(true);
    // })

    // Initialize the bizEntity for creating a new folder
    await this.initializeBizEntity();
  }
  OnSaveCompleted(event: any): void {
    if (event.success) {
      this.global.setBizEntityCreated(true);
    }
  }

  private async initializeBizEntity(): Promise<void> {
    // Get entity types to set the correct type for library folder
    const entityTypes = await this.bizEntityTypeStateStoreService.getState();
    const libraryFolderType = entityTypes?.find(type => type.category === BizEntityTypeCategory.HayagrivaLibFolder);

    if (!libraryFolderType) {
      this.logger.error('❌ Library Folder Type not found in entity types');
      return;
    }

    this.logger.info(`📁 Library Folder Type found: ${libraryFolderType.name} (${libraryFolderType.id})`);
    this.libraryExplorerStateService.setSelectedParentId(this.selectedBizEntityId || '');
    // Initialize empty bizEntity for creation
    const newBizEntity = createNewBizEntity(
      libraryFolderType,
      this.selectedBizEntityId || '',
      'cilLibrary',
      ['Folder']
    );

    // Set the signal to trigger change detection
    this.bizEntity.set(newBizEntity);

    this.logger.info(`📁 Form Add Folder initialized with parent: ${this.selectedBizEntityId}`);
  }
}
